import React from "react";
import "./GetinTouch.css";
import { FaArrowRight } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaMobileRetro } from "react-icons/fa6";
import axios from "axios";
import { useState } from "react";

const GetInTouch = () => {

  const [formData, setFormData] = useState({
    manager_id: "",
    url: "https://www.isolsgroup.com/",
    pipeline_id: "14",
    source_id: "36",
    name: "New Get in Touch Request Received | ISOLS Group Website | Home Page",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    contact_website: "",
    description: "",
    nspm: "",
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post(
        "https://erp.isolsgroup.com/api/v1/module/crm/leads/web_lead?id=101591&api_token=a1b962d0c1fb87354b47c32c88929ea2",
        formData,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data && response.data._resultMessage) {
        setMessage(response.data._resultMessage.replace("{{ID}}", response.data.id));
      } else {
        setMessage("Form submitted successfully!");
      }
    } catch (error) {
      console.error(error);
      setMessage("Error submitting form. Please try again later.");
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="top-footer">
      <div className="container">
        <div className="row">
          <div
            className="col-lg-12 gett" style={{ textAlign: "center", padding: "12px 2px 36px" }} >
            <h2
              className="heading-line line-right customColor customPseudoElBg wow fadeIn"
              style={{ fontSize: "40px", visibility: "visible", animationName: "fadeIn" }} >
              <strong>Get In Touch</strong>
            </h2>
          </div>

          <div className="col-xs-12 col-sm-6">
            <div
              className="b-mod-heading wow fadeInDown"
              style={{ padding: "17px 0px 18px", visibility: "visible", animationName: "fadeInDown" }}
            >
              <div className="col-xs-12 col-sm-12" style={{ paddingLeft: 0 }}>
                <div className="b-footer-right-side">
                  <div className="b-footer-contacts" style={{ marginLeft: 0 }}>
                    <div className="footer-contacts-item">
                      <h6 className="contacts-item-title" style={{ color: "#000" }}>
                        Head Office
                      </h6>
                      <p style={{ color: "#000" }}>
                        Plot No. 698, Sector 45, Gurugram, Haryana 122003, India
                      </p>
                      <a
                        href="https://www.google.com/maps/place/ISOLS+GROUP"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#ff9600", fontWeight: 400 }}
                      >
                        Click Here To Get The Google Direction
                      </a>
                    </div>
                    <div className="footer-contacts-item">
                      <h6 className="contacts-item-title" style={{ color: "#000" }}>
                        Branch Office
                      </h6>
                      <p style={{ color: "#000" }}>
                        83 Elgin Drive, Brampton, Ontario: L6Y1A9, Canada
                      </p>
                      <a
                        href="https://www.google.com/maps/place/ISOLS+GROUP+CANADA+INC"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#ff9600", fontWeight: 400 }}
                      >
                        Click Here To Get The Google Direction
                      </a>
                    </div>
                    <div className="footer-contacts-item">
                      <h6 className="contacts-item-title" style={{ color: "#000" }}>
                        Email
                      </h6>
                      <p>
                        <a style={{ color: "#000" }} href="mailto:info@isolsgroup.com">
                          info@isolsgroup.com
                        </a>
                      </p>
                    </div>
                    <div className="footer-contacts-item">
                      <h6 className="contacts-item-title" style={{ color: "#000" }}>
                        Phone
                      </h6>
                      <p style={{ color: "#000" }}>
                        <a style={{ color: "#000" }} href="tel:+919555411411">
                        <FaMobileRetro />
                        +91-9555-411-411
                        </a>{" "}
                        (India)
                        <br />
                        <a style={{ color: "#000" }} href="tel:+14373768000">
                        <FaWhatsapp /> +1(437) 376 8000
                        </a>{" "}
                        (US/Canada/Mexico)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

             <div className="col-xs-12 col-sm-6 wow slideInLeft text-inverse" style={{ visibility: "visible" }}>
                <form className="flowlu-form" onSubmit={handleSubmit}>
                  <div className="flowlu-row">
                    <table width="100%" border="0" className="flowlu-table-rows" style={{ borderCollapse: "collapse" }}>
                      <tbody>
                        <tr>
                          <td width="48%">
                            <input
                              type="text"
                              required
                              id="flowlu_contact_name"
                              placeholder="Your Name*"
                              name="contact_name"
                              value={formData.contact_name}
                              onChange={handleChange}
                              className="flowlu-input"
                            />
                          </td>
                          <td width="4%">&nbsp;</td>
                          <td width="48%">
                            <input
                              type="email"
                              required
                              id="flowlu_contact_email"
                              placeholder="Email Address*"
                              name="contact_email"
                              value={formData.contact_email}
                              onChange={handleChange}
                              className="flowlu-input"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="flowlu-row">
                    <input
                      type="text"
                      required
                      id="flowlu_contact_phone"
                      placeholder="Mobile*"
                      name="contact_phone"
                      value={formData.contact_phone}
                      onChange={handleChange}
                      className="flowlu-input"
                    />
                    <input
                      type="text"
                      id="flowlu_contact_website"
                      placeholder="Your Website"
                      name="contact_website"
                      value={formData.contact_website}
                      onChange={handleChange}
                      className="flowlu-input"
                    />
                    <textarea
                      id="flowlu_description"
                      rows="5"
                      name="description"
                      placeholder="Type Your Query"
                      value={formData.description}
                      onChange={handleChange}
                      className="flowlu-input"
                      style={{ width: "100%", height: "62px", borderRadius: "0px" }}
                    ></textarea>
                  </div>

                  <div className="flowlu-row flowlu-row-submit">
                    <button
                      type="submit"
                      disabled={loading}
                      className="flowlu-submit btn-default-arrow"
                    >
                      {loading ? "Submitting..." : <>Submit <FaArrowRight/> </>}
                    </button>
                  </div>

                  {message && (
                    <div
                      className="flowlu-notification"
                      style={{ marginTop: "15px", fontWeight: "bold", color: message.includes("Error") ? "red" : "green" }}
                    >
                      {message}
                    </div>
                  )}
                </form>
              </div>
          

        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
